import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { getAlimTalkTemplateByAltemp } from "../../../../../AdminApi/commFunc";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import { AdditionalTextArea } from "../../../AlimTalk/AlimTalkModal/TemplatePreviewBox";
import { ISunsetData } from "../SunsetDetail/SunsetDetailInfo";
import { getAlTempNumber } from "../SunsetDetail/SunsetReason";
import { sunsetDetailDataState } from "../SunsetDetail/SunsetSubs";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import SunsetAlimtalkCase from "./SunsetAlimtalkCase";

export interface INotiCase {
  matchingWaiting: boolean;
  before: boolean;
  underMonth: boolean;
  overMonthOwner: boolean;
  overMonthMember: boolean;
  invAcceptMember?: boolean;
}

export const notiCaseSaveState = atom<INotiCase>({
  key: "notiCaseSaveState",
  default: {
    matchingWaiting: false,
    before: false,
    underMonth: false,
    overMonthOwner: false,
    overMonthMember: false,
  },
});

export default function SunsetAlimtalk() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const sunsetDetailData = useRecoilValue(sunsetDetailDataState);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  console.log(sunsetDetailData);

  const isOptIn = sunsetDetailData?.sunsetType === 1; // opt-in

  const [notiCase, setNotiCase] = useState<INotiCase>(
    isOptIn
      ? {
          matchingWaiting: true,
          before: false,
          underMonth: false,
          overMonthOwner: false,
          overMonthMember: false,
          invAcceptMember: false,
        }
      : {
          matchingWaiting: true,
          before: false,
          underMonth: false,
          overMonthOwner: false,
          overMonthMember: false,
        }
  );
  const [notiCaseSave, setNotiCaseSave] = useRecoilState(notiCaseSaveState);
  const [inputValue, setInputValue] = useState(
    isOptIn // opt-in
      ? {
          matchingWaiting: "",
          before: "",
          underMonth: "",
          overMonthOwner: "",
          overMonthMember: "",
          invAcceptMember: "",
        }
      : {
          matchingWaiting: "",
          before: "",
          underMonth: "",
          overMonthOwner: "",
          overMonthMember: "",
        }
  );

  const altemp =
    location?.state?.sunsetData?.altemp ??
    +getAlTempNumber(sunsetDetailData?.sunsetReason ?? "") ??
    0;

  console.log(altemp);

  const allFalse = {
    matchingWaiting: false,
    before: false,
    underMonth: false,
    overMonthOwner: false,
    overMonthMember: false,
  };

  const template = getAlimTalkTemplateByAltemp(
    altemp,
    notiCase?.matchingWaiting
      ? 0
      : notiCase?.before
      ? 1
      : notiCase?.underMonth
      ? 2
      : notiCase?.overMonthOwner
      ? 3
      : notiCase?.overMonthMember
      ? 4
      : 5,
    sunsetDetailData?.sunsetType
  );

  console.log(inputValue);

  return (
    <>
      <SunsetAlimtalkTitle>케이스 별 확인</SunsetAlimtalkTitle>

      <SunsetAlimtalkCase
        notiCase={notiCase}
        notiCaseSave={notiCaseSave}
        setNotiCase={setNotiCase}
        sunsetType={sunsetDetailData?.sunsetType}
      />

      <AlimTalkContent>{template?.split("#{alert_msg}")[0]}</AlimTalkContent>

      {template?.includes("#{alert_msg}") && (
        <AdditionalTextArea
          ref={textareaRef}
          placeholder="추가 내용 입력(필수)"
          autoFocus={true}
          value={
            notiCase?.matchingWaiting
              ? inputValue?.matchingWaiting
              : notiCase?.before
              ? inputValue?.before
              : notiCase?.underMonth
              ? inputValue?.underMonth
              : notiCase?.overMonthOwner
              ? inputValue?.overMonthOwner
              : notiCase?.overMonthMember
              ? inputValue?.overMonthMember
              : inputValue?.invAcceptMember
          }
          onChange={(e) => {
            if (notiCase?.matchingWaiting) {
              setInputValue({
                ...inputValue,
                matchingWaiting: e.target.value,
              });
            } else if (notiCase?.before) {
              setInputValue({
                ...inputValue,
                before: e.target.value,
              });
            } else if (notiCase?.underMonth) {
              setInputValue({
                ...inputValue,
                underMonth: e.target.value,
              });
            } else if (notiCase?.overMonthOwner) {
              setInputValue({
                ...inputValue,
                overMonthOwner: e.target.value,
              });
            } else if (notiCase?.overMonthMember) {
              setInputValue({
                ...inputValue,
                overMonthMember: e.target.value,
              });
            } else if (notiCase?.invAcceptMember) {
              setInputValue({
                ...inputValue,
                invAcceptMember: e.target.value,
              });
            }
          }}
          required={true}
          style={{ maxHeight: 290 }}
        />
      )}

      {template?.split("#{alert_msg}")[1] && (
        <AlimTalkContent style={{ marginTop: 0 }}>
          {template?.split("#{alert_msg}")[1]?.replace("\r\n\r\n", "")}
        </AlimTalkContent>
      )}

      {buttonType !== "view" && (
        <ButtonContainer>
          <ConfirmBtn
            btnText="저장 및 다음"
            btnColor="mint"
            isDisabled={
              notiCaseSave?.matchingWaiting &&
              notiCaseSave?.before &&
              notiCaseSave?.underMonth &&
              notiCaseSave?.overMonthOwner &&
              notiCaseSave?.overMonthMember &&
              (isOptIn ? notiCaseSave?.invAcceptMember : true)
            }
            btnClickEvent={() => {
              if (notiCase?.matchingWaiting) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  matchingWaiting: true,
                });

                setNotiCase({
                  ...allFalse,
                  before: true,
                });
              } else if (notiCase?.before) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  before: true,
                });

                setNotiCase({
                  ...allFalse,
                  underMonth: true,
                });
              } else if (notiCase?.underMonth) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  underMonth: true,
                });

                setNotiCase({
                  ...allFalse,
                  overMonthOwner: true,
                });
              } else if (notiCase?.overMonthOwner) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  overMonthOwner: true,
                });

                setNotiCase({
                  ...allFalse,
                  overMonthMember: true,
                });
              } else if (notiCase?.overMonthMember) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  overMonthMember: true,
                });

                if (isOptIn) {
                  setNotiCase({
                    ...allFalse,
                    invAcceptMember: true,
                  });
                }
              } else if (isOptIn && notiCase?.invAcceptMember) {
                setNotiCaseSave({
                  ...notiCaseSave,
                  invAcceptMember: true,
                });
              }
            }}
          />
        </ButtonContainer>
      )}
    </>
  );
}

const SunsetAlimtalkTitle = styled.div`
  margin-top: 20px;
  font-size: 15px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: ${({ theme }) => theme.buttonColor.linePressed};
`;

const AlimTalkContent = styled.div`
  width: 100%;
  margin-top: 24px;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 16px;
  white-space: pre-line;
  line-break: anywhere;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray600};
`;

const ButtonContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
